import HTMLParser from 'html-react-parser';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

export interface AccordionBlockItem {
  title?: string | null;
  description?: string | null;
}

interface AccordionBlockProps {
  items: AccordionBlockItem[];
}

export function AccordionBlock({ items }: AccordionBlockProps) {
  const validItems = items.filter(item => item.title || item.description);
  if (validItems.length === 0) return null;

  return (
    <div className="px-4">
      <Accordion type="single" collapsible>
        {validItems.map((item, i) => (
          <AccordionItem
            key={i}
            value={`item-${i}`}
            className="data-[state=open]:border-jncquoi-neutral-200 border-b-[0.5px]"
          >
            <AccordionTrigger>{item.title}</AccordionTrigger>
            {item.description && (
              <AccordionContent>
                <div className="font-pp-neue-montreal text-jncquoi-neutral-1000 prose prose-sm max-w-none pb-6 text-[14px] leading-none tracking-[0.5px]">
                  {HTMLParser(item.description)}
                </div>
              </AccordionContent>
            )}
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
